import { createIcon } from './icon-utils';

export const UnderlineIcon = createIcon({
  path: 'M7.688 4.289v7.351c0 2.263 1.924 4.11 4.312 4.11 2.388 0 4.313-1.847 4.313-4.11V4.289h-.375a.75.75 0 1 1 0-1.5h2.25a.75.75 0 1 1 0 1.5h-.375v7.351c0 3.105-2.61 5.61-5.813 5.61s-5.813-2.505-5.813-5.61V4.289h-.375a.75.75 0 0 1 0-1.5h2.25a.75.75 0 0 1 0 1.5h-.374zm-4.125 16.2a.75.75 0 1 1 0-1.5h16.875a.75.75 0 1 1 0 1.5H3.563z',
});
